import React from 'react';
import { TypeAnimation } from 'react-type-animation';
import { Link } from 'react-router-dom';
// import video from '../src/assets/Kapil Technologies Website.mp4';

const HomeMainSection = () => {
  return (
    <div className="relative min-h-screen">
      {/* Hero Background Section with elegant gradient */}
      <div
        className="absolute inset-0 overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #CCFBF1, #DBEAFE, #E9D5FF)' }}
        
      >
        {/* Decorative circular elements */}
        <div
          className="absolute right-0 bottom-0 w-3/4 h-3/4 md:w-2/3 md:h-2/3 rounded-full opacity-20"
          style={{ backgroundColor: '#93C5FD' }}
        ></div>
        <div
          className="absolute left-0 top-0 w-1/2 h-1/2 rounded-full opacity-20"
          style={{ backgroundColor: '#D8B4FE' }}
        ></div>
      </div>

      
      
      {/* Main Content */}
      <div className="relative max-w-7xl mx-auto px-4 md:px-8 lg:px-12 pt-8 ">
        {/* Tag */}
        <div
          className="inline-block font-semibold mt-10 pt-2 text-6xl md:text-4xl text-[#4F46E5]"
          // style={{ backgroundColor: '#F97316', color: '#FFFFFF' }}
        >
         Transform Your <br />Business Excellence with
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div>
              <h1
                className="text-4xl md:text-3xl lg:text-4xl font-bold mb-4 leading-tight"
                style={{ color: '#1F2937' }}
              >
                <TypeAnimation
                  sequence={[
                    'End to End ERP Implementation',
                    1000,
                    'MES Implementation',
                    1000,
                    'Application Development',
                    1000,
                    'Infor Consulting Services ',
                    1000,
                    'SAP Staffing Services ',
                    1000,
                    'Managed Services & Support',
                    1000,
                    'Training & Consultation ',
                    1000,
                    'Digital Marketing Services'

    
                  ]}
                  wrapper="span"
                  cursor={true}
                  repeat={Infinity}
                  style={{
                    display: 'inline-block',
                    whiteSpace: 'nowrap',
                    color: '#1F2937',
                    fontWeight: "bold",
                    fontSize:"25px"
                  }}
                />
              </h1>
              <p
                className="text-lg md:text-xl  mt-6"
                style={{ color: '#4B5563' }}
              >
               Specializing in Cloud Computing, Implementation, and Digital Transformation to Drive Success through Innovative Operations.
              </p>
            </div>

            <div className="flex flex-wrap gap-4 mt-8">
              <button
                className="px-8 py-3 rounded-md font-medium transition-colors shadow-md hover:bg-[#4338CA]"
                style={{ backgroundColor: '#4F46E5', color: '#FFFFFF' }}
              >
              <Link to="/insights/aboutus" >  Know More</Link>
              </button>
              <button
                className="px-8 py-3 rounded-md font-medium transition-colors shadow-md hover:bg-[#EA580C]"
                style={{ backgroundColor: '#F97316', color: '#FFFFFF' }}
              >
                 <Link to="/contact">Connect with Us</Link>
              </button>
            </div>
            
            <div className="flex flex-wrap gap-6 mt-8">
              <div className="flex gap-12">
                <div className="text-center">
                  <div
                    className="text-3xl font-bold"
                    style={{ color: '#4F46E5' }}
                  >
                   95%
                  </div>
                  <div style={{ color: '#4B5563' }}>Customer Satisfaction Rate</div>
                </div>
                <div className="text-center">
                  <div
                    className="text-3xl font-bold"
                    style={{ color: '#4F46E5' }}
                  >
                    99%
                  </div>
                  <div style={{ color: '#4B5563' }}>Implementation Success Rate</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - Video/Image Section */}
          <div className="relative ">
            <div className="rounded-xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-300">
              <div
                className="relative aspect-video flex items-center justify-center"
                style={{ backgroundColor: '#1F2937' }}
              >
                <video
                  src="https://ik.imagekit.io/kqumni8l2/HomePage/Business%20Marketing%202024%20(1).mp4?updatedAt=1745827815994"
                  
                  className="mx-auto rounded-lg w-full h-full object-cover"
                  controls
                />
                <div
                  className="absolute inset-0 pointer-events-none"
                  style={{
                    background: 'linear-gradient(to top right, rgba(79,70,229,0.1), transparent)',
                  }}
                ></div>
              </div>
            </div>
            {/* Decorative element */}
            <div
              className="absolute -bottom-6 -right-6 w-24 h-24 rounded-full opacity-20"
              style={{ backgroundColor: '#F97316' }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeMainSection;


